<div class="chart">
  <canvas baseChart
          [data]="chartData"
          [type]="'bar'"
          [options]="chartOptions"
          (chartClick)="onChartClicked($event)"></canvas>
</div>
